export default __webpack_public_path__ + "static/media/GitHub.47125e57.svg";